import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ReactTemplate } from '@bingads-webui-react/react-template';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { ConfirmDialog } from '../common';
import { getStyles } from '../styles/identity-verification-dialog';

const Content = ({
  ablVerificationStatusLabel, confirmText, i18n,
}) => {
  const classes = useDefaultStyles(getStyles);
  return (
    <div className={classNames(classes.content)}>
      <p>{i18n.getString(_TL_('Your advertiser identity verification status is shared across your accounts with the same business location and legal name.'))}</p>
      <ReactTemplate
        model={{
          ablVerificationStatusLabel: <span className="bold">{ablVerificationStatusLabel}</span>,
          confirmText: <span className="bold">{confirmText}</span>,
        }}
        template={i18n.getString(_TL_("You've provided an updated business location that is {{ablVerificationStatusLabel}}. If you're already verified, selecting {{confirmText}} will cause the existing verification status to change, and you'll be required to resubmit verification."))}
      />
      <p>{i18n.getString(_TL_("Note: This doesn't apply to monthly invoiced accounts with an SAP payment method, as they are automatically verified."))}</p>
    </div>
  );
};

const ChinaAIVContent = ({
  ablVerificationStatusLabel, i18n,
}) => {
  const classes = useDefaultStyles(getStyles);
  const contentTemplate = i18n.getString(_TL_("Advertiser identity verification status is shared across accounts that have the same business location. The verification status for the business location you entered is {{ablVerificationStatusLabel}}. The same verification status will be applied to this account if you proceed, and all your other verifications' status will change to {{bold}}Not verified{{/bold}}."));
  return (
    <div className={classNames(classes.content)}>
      <ReactTemplate
        model={{
          ablVerificationStatusLabel: <span className="bold">{ablVerificationStatusLabel}</span>,
          bold: text => (<span className="bold">{text}</span>),
        }}
        template={contentTemplate}
      />
    </div>
  );
};

export const VerificationStatusChangeDialog = ({
  i18n,
  ablVerificationStatusLabel,
  onConfirm,
  onDecline,
  isChinaMarket,
}) => {
  const ContentComponent = isChinaMarket ? ChinaAIVContent : Content;
  return (<ConfirmDialog
    name="verification-status-change"
    onConfirm={onConfirm}
    onDecline={onDecline}
    title={i18n.getString(_TL_('Verification status change'))}
    content={<ContentComponent
      ablVerificationStatusLabel={ablVerificationStatusLabel}
      confirmText={i18n.getString(_TL_('Proceed'))}
      i18n={i18n}
    />}
    confirmButtonText={i18n.getString(_TL_('Proceed'))}
    declineButtonText={i18n.getString(_TL_('Cancel'))}
  />);
};

VerificationStatusChangeDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ablVerificationStatusLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  isChinaMarket: PropTypes.bool,
};

VerificationStatusChangeDialog.defaultProps = {
  isChinaMarket: false,
};

Content.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ablVerificationStatusLabel: PropTypes.string.isRequired,
};

ChinaAIVContent.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ablVerificationStatusLabel: PropTypes.string.isRequired,
};
